@if (folder) {
	<div class="carousel-wrapper" stagesClickStopPropagation>
		<div
			class="carousel-inner"
			[class.transition-enabled]="transitionEnabled"
			[class.position-center]="slidePosition === 'center'"
			[class.position-left]="slidePosition === 'left'"
			(transitionend)="onSlideTransitionEnd($event)"
		>
			@for (item of visibleFolders; track getFolderId($index, item)) {
				<div class="carousel-item">
					<div class="list">
						<div class="list-item parent" [ngClass]="{ active: item.id === preSelected() }">
							@if (item.parent) {
								<div class="nav-button parent">
									<button
										[attr.title]="'up' | translate"
										[attr.aria-label]="'up' | translate"
										(click)="onUp($any(item.parent))"
										class="action"
									>
										<i class="ico ico-chevron-left-small"></i>
									</button>
								</div>
							}
							@if (item.selectable) {
								<a class="label clickable" (click)="selectWorkspace(item)">
									<div class="text">
										<span class="h6">
											{{ item.path }}
											@if (item.parent) {
												&nbsp;&gt;
											}
										</span>
										<span class="h3">{{ item.name }}</span>
									</div>
								</a>
							}
							@if (!item.selectable) {
								<div class="label">
									<div class="text">
										<span class="h6">
											{{ item.path }}
											@if (item.parent) {
												&nbsp;&gt;
											}
										</span>
										<span class="h3">{{ item.name }}</span>
									</div>
								</div>
							}
						</div>
						@if (filterChildren(item.children); as workspaces) {
							@for (workspace of workspaces; track getId($index, workspace)) {
								<div
									class="list-item child"
									[ngClass]="{ active: preSelected() === workspace.id, 'split-hover': workspace.hasChildren }"
								>
									<div class="workspace-link">
										@if (workspace.selectable) {
											<a class="label clickable" (click)="selectWorkspace(workspace)">
												<div class="text">
													<span class="h3" [innerHTML]="workspace.name | highlightMatches: filterTerm"></span>
												</div>
											</a>
										}
										@if (!workspace.selectable) {
											<div class="label">
												<div class="text">
													<span class="h3" [innerHTML]="workspace.name | highlightMatches: filterTerm"></span>
												</div>
											</div>
										}
									</div>
									@if (workspace.hasChildren) {
										<div class="nav-button child">
											<button
												[attr.title]="'navigation.workspace.navigatetochild' | translate"
												[attr.aria-label]="'navigation.workspace.navigatetochild' | translate"
												(click)="onDown(workspace)"
											>
												<div class="right action">
													<i class="ico ico-chevron-right-small"></i>
												</div>
											</button>
										</div>
									}
								</div>
							}
							@if (workspaces.length === 0) {
								<div class="list-item empty">
									<div class="label">
										<p translate="navigation.workspace.filter.nothing_found"></p>
									</div>
								</div>
							}
						}
					</div>
				</div>
			}
		</div>
	</div>
} @else {
	<stages-spin class="spin-without-button" size="sm" />
}
